import { createSelector } from 'reselect'
import { getArrayOfObjectValues } from '../../utils';

export const getMixtureOrdersSelector = createSelector(
  mixtureOrder => mixtureOrder.mixtureOrder,
  (mixtureOrdersById) => getArrayOfObjectValues(mixtureOrdersById)
);